import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import bcArrow from '../../assets/images/bc_arrow.svg';
import './BackArrow.css';

const NavArrow = (props) => {
  const { to, label } = props;
  return (
    <div>
      <Link styleName="bcLink" to={to}>
        <img
          src={bcArrow}
          alt={`Back to ${label}`}
          styleName="backArrow"
        />
        <div styleName="label">{label}</div>
      </Link>
    </div>
  );
};

NavArrow.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string,
};

NavArrow.defaultProps = {
  label: '',
};

export default NavArrow;



// WEBPACK FOOTER //
// ./src/components/Button/BackArrow.js